var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import { permissionInputParts } from "@/composables/datasetPermissions";
import { withPrefix } from "@/utils/redirect";
export function getPermissionsUrl(historyId) {
    return `/history/permissions?id=${historyId}`;
}
export function getPermissions(historyId) {
    const permissionsUrl = getPermissionsUrl(historyId);
    return axios.get(withPrefix(permissionsUrl));
}
export function setPermissions(historyId, formContents) {
    const permissionsUrl = getPermissionsUrl(historyId);
    return axios.put(withPrefix(permissionsUrl), formContents);
}
export function makePrivate(historyId, permissionResponse) {
    const { manageInput } = permissionInputParts(permissionResponse.inputs);
    const managePermissionValue = manageInput.value[0];
    const access = [managePermissionValue];
    const formValue = {
        DATASET_MANAGE_PERMISSIONS: [managePermissionValue],
        DATASET_ACCESS: access,
    };
    return setPermissions(historyId, formValue);
}
export function isHistoryPrivate(permissionResponse) {
    return __awaiter(this, void 0, void 0, function* () {
        const { accessInput } = permissionInputParts(permissionResponse.inputs);
        return accessInput.value.length >= 1;
    });
}
